import { bl_rvm_cfp_program_member_RowClass } from '../../../dbschema/bl_rvm_cfp_program_member.model';
import { BaseContainerModel } from '../../base-container.model';

export class CfpProgramMemberContainerModel extends BaseContainerModel {
  bl_rvm_cfp_program_member: bl_rvm_cfp_program_member_RowClass = new bl_rvm_cfp_program_member_RowClass();
}
